module.exports = __webpack_public_path__ + "img/tuli.242be0bd.png";